import { getTemplateValues } from '@recruiting-solutions/rs-shared';
import { Component, h, Host, Prop, State } from '@stencil/core';

@Component({
    tag: 'arv-server-warning',
    styleUrl: 'arv-server-warning.scss',
    shadow: true,
})
export class ArvServerWarning {
    @Prop({ attribute: 'i18n-component' }) i18nComponent: string = 'serverWarningLandingPage';

    @State() numColumns: number = 3;

    i18n: any;
    data: { label: string; email: string }[];

    componentWillLoad() {
        this.onResize();
        window.addEventListener('resize', () => {
            this.onResize();
        });

        this.i18n = getTemplateValues(this.i18nComponent);
        this.data = [];

        for (let j = 0; j < 11; ++j) {
            const label = this.i18n(`country${j}Label`);
            const email = this.i18n(`country${j}Email`);

            if (label && email) {
                this.data.push({ label: label, email: email });
            }
        }
    }

    render() {
        return (
            <Host>
                <div class="background">
                    <div class="container">
                        <h1>{this.i18n('title')}</h1>
                        <div innerHTML={this.i18n?.('description')}></div>
                        {this.shouldRenderTable() && this.renderTable()}
                        <div innerHTML={this.i18n?.('subTitle')}></div>
                    </div>
                </div>
            </Host>
        );
    }

    shouldRenderTable(): boolean {
        return this.data.length > 0;
    }

    renderTable(): HTMLElement {
        return <table>{this.renderTableRow()}</table>;
    }
    renderTableRow() {
        let result: HTMLElement[] = [];
        for (let i = 0; i < this.data.length; i += this.numColumns) {
            const start = i;
            const end = i + this.numColumns;

            const rowData = this.data.slice(start, end);
            // insert dummies so table border styling doesnt go brrrr
            while (rowData.length < this.numColumns) {
                rowData.push({ label: '', email: '' });
            }
            result.push(
                <tr>
                    {rowData.map(data => {
                        return renderCell(data.label, data.email);
                    })}
                </tr>,
            );
        }
        return result;
    }

    onResize() {
        const width = window.innerWidth;
        let numColumns = 3;
        if (width < 768) {
            numColumns = 1;
        } else if (width < 1280) {
            numColumns = 2;
        }
        if (numColumns != this.numColumns) {
            this.numColumns = numColumns;
        }
    }
}

const renderCell = (title: string, email: string) => {
    return (
        <td>
            <div class="title">{title}</div>
            <a class="contact" href={`mailto: ${email}`}>
                {email}
            </a>
        </td>
    );
};
